import { useCallback, useMemo } from 'react';

import { Loaders } from '@components';
import { useBaseStore } from '@store';

interface LoaderOutput {
	hide: () => void;
	show: () => void;
	isVisible: boolean;
}

export const useLoader = (loaderName: Loaders): LoaderOutput => {
	const hideLoader = useBaseStore((state) => state.hideLoader);
	const showLoader = useBaseStore((state) => state.showLoader);
	const visibleLoader = useBaseStore((state) => state.visibleLoader);

	const show = useCallback(() => {
		showLoader(loaderName);
	}, [loaderName, showLoader]);

	const isVisible = useMemo(() => {
		return visibleLoader === loaderName;
	}, [loaderName, visibleLoader]);

	return {
		hide: hideLoader,
		show,
		isVisible,
	};
};
